<div class="ad-skin">
  <div class="d-none d-xl-block">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adSkinProps"
    ></flo-lazy>
  </div>
</div>
<main data-test="search-page" class="search-page">
  <div class="mb-3 d-none d-lg-flex position-relative justify-content-center lazy-leaderboard-container">
    <flo-lazy
      class="leaderboard-center"
      [componentConstructor]="AdComponent"
      [initialProps]="adLeaderboardLarge"
      [detectorHeight]="90"
      [detectorWidth]="728"
    ></flo-lazy>
  </div>
  <div class="mb-3 d-none d-md-flex d-lg-none justify-content-center position-relative lazy-leaderboard-container">
    <flo-lazy
      class="leaderboard-center"
      [componentConstructor]="AdComponent"
      [initialProps]="adLeaderboardSmall"
      [detectorHeight]="90"
      [detectorWidth]="728"
    ></flo-lazy>
  </div>
  <div class="container min-vh-100 right-rail">
    <div class="py-3 px-3 px-lg-4 w-100">
      <h1 data-test="search-title" class="h3 mb-0">Search Results</h1>
    </div>
    <div class="row no-gutters main-row" data-test="search-container">
      <section class="search-content col-md-12 col-lg-8 pb-5 px-0 px-md-4">
        <div class="mb-4 px-4 px-md-0 search-min-width">
          <flo-search-input-next-gen
            [searchTerm]="searchQueryParam$ | async"
            (search)="updateSearchQueryParam($event)"
            data-test="search-input"
          ></flo-search-input-next-gen>
        </div>
        <!-- skeleton -->
        <ng-container *ifLoaded="searchLayout$ | async; template: 'search-page'">
          <ng-container *ngIf="searchLayout$ | async as results;">
            <ng-container *ngIf="results.length > 0; else showNoResults">
              <!-- tabs -->
              <div class="row mb-0 mb-md-4 pb-0" *ngIf="searchTabs$ | async as tabs" data-test="tabs">
                <ul data-test="search-tabs-container"
                    class="tabs-container border-bottom border-grey-300 justify-content-between flex-nowrap mb-0 px-4 p-md-0"
                    role="tablist">
                  <li *ngFor="let tab of tabs; trackBy: trackByTab"
                      data-test="search-tab-item"
                      class="tab-label border-top-0 px-0"
                      [class.tab-active]="tab.active">
                    <a floAnalytics eventName="Tab Clicked"
                       class="font-family-regular nav-link apply-text-active p-0 h-100 w-100 d-flex align-items-center justify-content-center"
                       (click)="updateTypeQueryParam(tab.value)">{{ tab.text }}</a>
                  </li>
                </ul>
              </div>
              <!--Data Loading Spinner-->
              <ng-container *ngIf="isContentLoading$ | async; else searchResults">
                <div data-test="search-spinner" class="d-flex spinner-container"><div class="spinner-border text-light d-flex m-auto"></div></div>
              </ng-container>
              <ng-template #searchResults>
                  <div class="px-4 px-md-0 pb-5" data-test="search-hits">
                    <div *ngFor="let result of results; let i = index; trackBy: trackById" class="d-flex flex-column px-0 py-3 border-bottom border-grey-300">
                      <flo-static-content-card [card]="result | searchItemToCardModel:i:results.length:(siteId$ | async) ?? 0 "></flo-static-content-card>
                    </div>
                  </div>
                  <ng-container *ngIf="pagination$ | async as pages">
                    <flo-pagination data-test="pagination-wrapper" [pagination]="pages"></flo-pagination>
                  </ng-container>
              </ng-template>
            </ng-container>
          </ng-container>
          <!-- no results -->
          <ng-template #showNoResults>
            <div class="pt-4 px-4 px-md-0" data-test="search-no-results">
              <flo-no-results [currentQueryText]="searchQueryParam$ | async"></flo-no-results>
            </div>
          </ng-template>
        </ng-container>
      </section>
      <aside class="search-right-rail col-md-12 col-lg-4 rail border-grey-300 d-none d-lg-flex">
        <div class="d-flex justify-content-center stick-to-header">
          <flo-lazy
            [componentConstructor]="AdComponent"
            [initialProps]="adRightRail"
            [detectorHeight]="600"
            [detectorWidth]="300"
            [threshold]="0.25"
          ></flo-lazy>
        </div>
      </aside>
    </div>
  </div>
  <flo-adhesion-footer>
    <div class="adhesion-ad d-sm-none">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adAdhesion"
      ></flo-lazy>
    </div>
  </flo-adhesion-footer>
</main>
